
import axios, { CancelTokenSource } from "axios";
import apiService from "./apiService";

const httpClient = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
    withCredentials: true
});

const fileService = {
    getCancelToken: () => {
        return axios.CancelToken.source();
    },
    uploadSellerLogo: async (fileData: any, onUploadProgress: any) => {
        const formData = new FormData();
        formData.append("file", fileData);
        
        return await apiService.post(`File/SellerLogo/`, formData, {
            onUploadProgress 
        });
    },
    uploadItemImage: async (itemId: number, files: File[], onUploadProgress: any) => {
        const formData = new FormData();
        files.forEach((file) => {
            formData.append('files', file); 
        });
        
        return await apiService.post(`File/${itemId}/ItemImages/`, formData, {
            onUploadProgress 
        });
    },
    deleteItemImage: async (itemId: number, itemImageName: string) => {
        return await apiService.delete(`File/${itemId}/ItemImage?imageName=${itemImageName}`);
    },
    downloadFile: async (path: string, onProgress: any, cancelToken?: CancelTokenSource) => {
        return await httpClient.get(path, {
            responseType: 'blob',
            cancelToken: cancelToken ? cancelToken.token : undefined,
            onDownloadProgress: onProgress
        });
    }
}

export default fileService;